import { connect } from 'react-redux';
import { exposActions } from '../../../../../redux/admin/expos/actions';
import DeleteExpoModal from './index';

const mapDispatchToProps = {
  deleteExpo: exposActions.deleteExpo,
};

export default connect(null, mapDispatchToProps)(DeleteExpoModal);
